/* eslint-disable */
import { css } from 'lit';

export default css`
	/* stylelint-disable */
  :host {
    display: contents;
  }
`;
